import React from 'react'
import { flattenNestedObject } from '../../../lib'
import ContentSection from '../../../components/ContentSection'
import TextTable from '../../../components/TextTable'

export default function SummativePracticalAssessmentTask({
  name,
  tasks,
  introduction,
}) {
  return (
    <TextTable
      heading={name}
      noRowsMsg="No tasks or introduction."
      rows={[
        ...(introduction ? [<ContentSection content={introduction} />] : []),
        ...[].concat(
          ...tasks.map(task => flattenNestedObject(task, 'subtasks')),
        ),
      ]}
      component={({ children }) => {
        return children.task ? <span>{children.task}</span> : children
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/FormativePracticalAssessments/SummativePracticalAssessmentTask.js